import api from '../services/api';
import { ICompany } from '../shared/interfaces';

export const getFindCompany = async (): Promise<ICompany | null> => {
  const response = await api.get(`/company/find`);
  return response.data;
};

export const postCompany = async (payload: any): Promise<ICompany> => {
  const response = await api.post(`/company`, payload);
  return response.data;
};

export const patchCompany = async (
  id: string | undefined,
  payload: any,
): Promise<ICompany> => {
  if (!id) {
    throw new Error('ID da empresa não fornecido.');
  }
  const response = await api.patch(`/company/${id}`, payload);
  return response.data;
};

export const postRemoveImageCompany = async (label: string | null) => {
  if (!label) {
    throw new Error('label da empresa não fornecido.');
  }
  const response = await api.post('/company/image/remove', {
    label,
  });
  return response.data;
};

export const putUploadImageCompany = async (payload: any) => {
  const response = await api.put(`company/images`, payload);
  response.data;
};
